module.exports = "/images/video_placeholder.webp?a9c1968ec64fe6fd7c4c8c23ae96a3ef";